export default "__VITE_ASSET__DFzd2AMw__"